import styled from 'styled-components';

const AlertMessage = styled.div`
    text-align: center;
`;

export default AlertMessage;
